import { useState, useEffect } from "react";
import { subirDatos } from "./syncSupabase";
import { STORAGE_CUENTAS } from "./FinanzasConfig";

const STORAGE_CXC = 'alqos_cxc_cxp';
const STORAGE_CAJA = 'alqos_movimientos_caja';

function hoy() { return new Date().toISOString().slice(0, 10); }
const nombreEntidad = (e) => e?.nombre || e?.razonSocial || '(sin nombre)';

const ESTADOS = {
  pendiente: { label: 'Pendiente', color: '#d97706' },
  parcial:   { label: 'Parcial',   color: '#2A7FFF' },
  pagado:    { label: 'Pagado',    color: '#16a34a' },
  vencido:   { label: 'Vencido',   color: '#dc2626' },
};

const NUEVA_VACIA = { entidadId: '', documentoOrigen: '', montoOriginal: '', fechaEmision: hoy(), fechaVencimiento: '' };
const COBRO_VACIO = { monto: '', cuentaCajaId: '', fecha: hoy(), concepto: '' };

export default function CuentasCobrarPagar({ onVolver, oscuro, usuario }) {
  const [items, setItems] = useState([]);
  const [cuentas, setCuentas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [tab, setTab] = useState('cobrar');
  const [filtroEstado, setFiltroEstado] = useState('todos');
  const [busqueda, setBusqueda] = useState('');
  const [showNueva, setShowNueva] = useState(false);
  const [nueva, setNueva] = useState(NUEVA_VACIA);
  const [registrando, setRegistrando] = useState(null);
  const [cobro, setCobro] = useState(COBRO_VACIO);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    (async () => {
      try { setItems(JSON.parse(localStorage.getItem(STORAGE_CXC) || '[]')); } catch {}
      try { setCuentas(JSON.parse(localStorage.getItem(STORAGE_CUENTAS) || '[]')); } catch {}
      try { setClientes(JSON.parse(localStorage.getItem('alqos_clientes') || '[]')); } catch {}
      try { setProveedores(JSON.parse(localStorage.getItem('alqos_proveedores') || '[]')); } catch {}
      setCargando(false);
    })();
    const onSync = () => {
      try { setItems(JSON.parse(localStorage.getItem(STORAGE_CXC) || '[]')); } catch {}
      try { setCuentas(JSON.parse(localStorage.getItem(STORAGE_CUENTAS) || '[]')); } catch {}
    };
    window.addEventListener('supabase-sync-complete', onSync);
    return () => window.removeEventListener('supabase-sync-complete', onSync);
  }, []);

  const guardarItems = (lista) => {
    setItems(lista);
    localStorage.setItem(STORAGE_CXC, JSON.stringify(lista));
    subirDatos(STORAGE_CXC);
  };
  const guardarCuentas = (lista) => {
    setCuentas(lista);
    localStorage.setItem(STORAGE_CUENTAS, JSON.stringify(lista));
    subirDatos(STORAGE_CUENTAS);
  };
  const guardarMovimiento = (mov) => {
    const lista = JSON.parse(localStorage.getItem(STORAGE_CAJA) || '[]');
    const nuevaLista = [mov, ...lista];
    localStorage.setItem(STORAGE_CAJA, JSON.stringify(nuevaLista));
    subirDatos(STORAGE_CAJA);
  };

  const entidades = tab === 'cobrar' ? clientes : proveedores;
  const cuentasCaja = cuentas.filter(c => c.activo !== false && c.codigo?.startsWith('1.1.01'));

  const estadoEfectivo = (item) => {
    if (item.estado !== 'pagado' && item.fechaVencimiento && item.fechaVencimiento < hoy()) return 'vencido';
    return item.estado;
  };

  const visibles = items
    .filter(i => i.tipo === tab)
    .filter(i => filtroEstado === 'todos' || estadoEfectivo(i) === filtroEstado)
    .filter(i => !busqueda.trim() || i.entidadNombre?.toLowerCase().includes(busqueda.toLowerCase()) || i.documentoOrigen?.toLowerCase().includes(busqueda.toLowerCase()));

  const abrirNueva = () => { setNueva(NUEVA_VACIA); setShowNueva(true); };

  const crearItem = () => {
    if (!nueva.entidadId) return alert(tab === 'cobrar' ? 'Seleccioná un cliente' : 'Seleccioná un proveedor');
    if (!(Number(nueva.montoOriginal) > 0)) return alert('El monto debe ser mayor a 0');
    const entidad = entidades.find(e => e.id === Number(nueva.entidadId));
    const item = {
      id: Math.floor(Date.now()),
      tipo: tab,
      entidadTipo: tab === 'cobrar' ? 'cliente' : 'proveedor',
      entidadId: Number(nueva.entidadId),
      entidadNombre: nombreEntidad(entidad),
      documentoOrigen: nueva.documentoOrigen,
      montoOriginal: Number(nueva.montoOriginal),
      montoPendiente: Number(nueva.montoOriginal),
      fechaEmision: nueva.fechaEmision,
      fechaVencimiento: nueva.fechaVencimiento || null,
      estado: 'pendiente',
      asientoId: null,
    };
    guardarItems([item, ...items]);
    setShowNueva(false);
  };

  const abrirRegistrar = (item) => { setCobro({ ...COBRO_VACIO, monto: item.montoPendiente }); setRegistrando(item); };

  const confirmarCobroPago = () => {
    const monto = Number(cobro.monto || 0);
    if (monto <= 0 || monto > registrando.montoPendiente) return alert(`El monto debe ser mayor a 0 y menor o igual al pendiente ($${registrando.montoPendiente})`);
    if (!cobro.cuentaCajaId) return alert('Seleccioná la cuenta de caja/bancos');

    const movId = Math.floor(Date.now());
    const movimiento = {
      id: movId,
      cuentaId: Number(cobro.cuentaCajaId),
      tipo: registrando.tipo === 'cobrar' ? 'ingreso' : 'egreso',
      monto,
      concepto: cobro.concepto || `${registrando.tipo === 'cobrar' ? 'Cobro' : 'Pago'} ${registrando.documentoOrigen || registrando.entidadNombre}`,
      cxcCxpId: registrando.id,
      asientoId: null,
      fecha: cobro.fecha,
      createdAt: new Date().toISOString(),
    };
    guardarMovimiento(movimiento);

    const cuentaCaja = cuentas.find(c => c.id === Number(cobro.cuentaCajaId));
    if (cuentaCaja) {
      const delta = registrando.tipo === 'cobrar' ? monto : -monto; // ingreso suma, egreso resta (cuenta activo)
      guardarCuentas(cuentas.map(c => c.id === cuentaCaja.id ? { ...c, saldo: Number((c.saldo || 0) + delta) } : c));
    }

    const nuevoPendiente = Number((registrando.montoPendiente - monto).toFixed(2));
    const nuevoEstado = nuevoPendiente <= 0 ? 'pagado' : 'parcial';
    guardarItems(items.map(i => i.id === registrando.id ? { ...i, montoPendiente: Math.max(nuevoPendiente, 0), estado: nuevoEstado } : i));

    setRegistrando(null);
  };

  const inp = { width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #E5E7EB', fontSize: '13px', boxSizing: 'border-box', fontFamily: 'Inter, sans-serif' };
  const lbl = { fontSize: '11px', fontWeight: '600', color: '#6B7280', marginBottom: '4px', display: 'block' };
  const TabBtn = ({ id, label }) => (
    <button onClick={() => { setTab(id); setFiltroEstado('todos'); setBusqueda(''); }} style={{ padding: '7px 16px', borderRadius: '8px', border: 'none', fontSize: '12px', fontWeight: '500', cursor: 'pointer', background: tab === id ? '#1C3FAA' : 'transparent', color: tab === id ? 'white' : '#6B7280' }}>{label}</button>
  );

  if (cargando) return <div style={{ padding: '40px', textAlign: 'center', color: '#9CA3AF' }}>Cargando…</div>;

  return (
    <div style={{ padding: '24px', fontFamily: 'Inter, sans-serif', background: '#E8E9F6', minHeight: '100vh' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <button onClick={onVolver} style={{ background: 'none', border: '1px solid #E5E7EB', borderRadius: '8px', padding: '6px 12px', fontSize: '12px', cursor: 'pointer', color: '#6B7280' }}>← Menú</button>
          <span style={{ fontSize: '22px' }}>💳</span>
          <h1 style={{ fontSize: '20px', fontWeight: '700', color: '#1C3FAA', margin: 0 }}>Cuentas por Cobrar / Pagar</h1>
        </div>
        <button onClick={abrirNueva} style={{ background: '#1C3FAA', color: 'white', border: 'none', borderRadius: '10px', padding: '10px 18px', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>+ Nueva</button>
      </div>

      <div style={{ display: 'flex', gap: '4px', background: 'white', padding: '4px', borderRadius: '10px', border: '1px solid #E5E7EB', width: 'fit-content', marginBottom: '16px' }}>
        <TabBtn id="cobrar" label="Por Cobrar" />
        <TabBtn id="pagar" label="Por Pagar" />
      </div>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '16px' }}>
        <input style={{ ...inp, maxWidth: '260px' }} placeholder="Buscar por entidad o documento…" value={busqueda} onChange={e => setBusqueda(e.target.value)} />
        <select style={{ ...inp, maxWidth: '160px' }} value={filtroEstado} onChange={e => setFiltroEstado(e.target.value)}>
          <option value="todos">Todos los estados</option>
          {Object.entries(ESTADOS).map(([k, v]) => <option key={k} value={k}>{v.label}</option>)}
        </select>
      </div>

      <div style={{ background: 'white', borderRadius: '14px', border: '1px solid #E5E7EB', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ background: '#F9FAFB' }}>
              {['Entidad', 'Documento', 'Monto original', 'Pendiente', 'Vencimiento', 'Estado', ''].map(h => (
                <th key={h} style={{ padding: '10px 14px', fontSize: '11px', fontWeight: '600', color: '#6B7280', textAlign: 'left', borderBottom: '1px solid #E5E7EB' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {visibles.length === 0 ? (
              <tr><td colSpan={7} style={{ padding: '60px', textAlign: 'center', color: '#9CA3AF' }}>Sin registros</td></tr>
            ) : visibles.map(i => {
              const est = estadoEfectivo(i);
              return (
                <tr key={i.id}>
                  <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontWeight: '600', fontSize: '13px' }}>{i.entidadNombre}</td>
                  <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px' }}>{i.documentoOrigen || '—'}</td>
                  <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px' }}>${Number(i.montoOriginal).toLocaleString('es-AR')}</td>
                  <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px', fontWeight: '600' }}>${Number(i.montoPendiente).toLocaleString('es-AR')}</td>
                  <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6', fontSize: '12px' }}>{i.fechaVencimiento || '—'}</td>
                  <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6' }}>
                    <span style={{ background: `${ESTADOS[est]?.color}18`, color: ESTADOS[est]?.color, fontSize: '11px', padding: '2px 8px', borderRadius: '6px', fontWeight: '600' }}>{ESTADOS[est]?.label}</span>
                  </td>
                  <td style={{ padding: '11px 14px', borderBottom: '1px solid #F3F4F6' }}>
                    {i.estado !== 'pagado' && (
                      <button onClick={() => abrirRegistrar(i)} style={{ background: '#16a34a', color: 'white', border: 'none', borderRadius: '6px', padding: '4px 10px', cursor: 'pointer', fontSize: '11px', fontWeight: '600' }}>
                        Registrar {tab === 'cobrar' ? 'Cobro' : 'Pago'}
                      </button>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {showNueva && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '440px', padding: '24px' }}>
            <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#1C3FAA', margin: '0 0 16px' }}>+ Nueva cuenta por {tab === 'cobrar' ? 'cobrar' : 'pagar'}</h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <label style={lbl}>{tab === 'cobrar' ? 'Cliente' : 'Proveedor'} *</label>
                <select style={inp} value={nueva.entidadId} onChange={e => setNueva(n => ({ ...n, entidadId: e.target.value }))}>
                  <option value="">— Seleccionar —</option>
                  {entidades.map(e => <option key={e.id} value={e.id}>{nombreEntidad(e)}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Documento de origen</label>
                <input style={inp} placeholder="Ej: VTA-2026-0012" value={nueva.documentoOrigen} onChange={e => setNueva(n => ({ ...n, documentoOrigen: e.target.value }))} />
              </div>
              <div>
                <label style={lbl}>Monto *</label>
                <input style={inp} type="number" value={nueva.montoOriginal} onChange={e => setNueva(n => ({ ...n, montoOriginal: e.target.value }))} />
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div>
                  <label style={lbl}>Fecha emisión</label>
                  <input style={inp} type="date" value={nueva.fechaEmision} onChange={e => setNueva(n => ({ ...n, fechaEmision: e.target.value }))} />
                </div>
                <div>
                  <label style={lbl}>Vencimiento</label>
                  <input style={inp} type="date" value={nueva.fechaVencimiento} onChange={e => setNueva(n => ({ ...n, fechaVencimiento: e.target.value }))} />
                </div>
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => setShowNueva(false)} style={{ flex: 1, padding: '10px', borderRadius: '10px', border: '1px solid #E5E7EB', background: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer', color: '#6B7280' }}>Cancelar</button>
              <button onClick={crearItem} style={{ flex: 2, padding: '10px', borderRadius: '10px', border: 'none', background: '#1C3FAA', color: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Guardar</button>
            </div>
          </div>
        </div>
      )}

      {registrando && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: 'white', borderRadius: '16px', width: '420px', padding: '24px' }}>
            <h2 style={{ fontSize: '16px', fontWeight: '700', color: '#1C3FAA', margin: '0 0 4px' }}>
              Registrar {registrando.tipo === 'cobrar' ? 'Cobro' : 'Pago'}
            </h2>
            <p style={{ fontSize: '12px', color: '#6B7280', margin: '0 0 16px' }}>{registrando.entidadNombre} · Pendiente: ${Number(registrando.montoPendiente).toLocaleString('es-AR')}</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              <div>
                <label style={lbl}>Monto *</label>
                <input style={inp} type="number" value={cobro.monto} onChange={e => setCobro(c => ({ ...c, monto: e.target.value }))} />
              </div>
              <div>
                <label style={lbl}>Cuenta de Caja/Bancos *</label>
                <select style={inp} value={cobro.cuentaCajaId} onChange={e => setCobro(c => ({ ...c, cuentaCajaId: e.target.value }))}>
                  <option value="">— Seleccionar —</option>
                  {cuentasCaja.map(c => <option key={c.id} value={c.id}>{c.codigo} — {c.nombre}</option>)}
                </select>
              </div>
              <div>
                <label style={lbl}>Fecha</label>
                <input style={inp} type="date" value={cobro.fecha} onChange={e => setCobro(c => ({ ...c, fecha: e.target.value }))} />
              </div>
              <div>
                <label style={lbl}>Concepto</label>
                <input style={inp} value={cobro.concepto} onChange={e => setCobro(c => ({ ...c, concepto: e.target.value }))} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
              <button onClick={() => setRegistrando(null)} style={{ flex: 1, padding: '10px', borderRadius: '10px', border: '1px solid #E5E7EB', background: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer', color: '#6B7280' }}>Cancelar</button>
              <button onClick={confirmarCobroPago} style={{ flex: 2, padding: '10px', borderRadius: '10px', border: 'none', background: '#16a34a', color: 'white', fontSize: '13px', fontWeight: '600', cursor: 'pointer' }}>Confirmar</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
